export { FigmaLogo } from './FigmaLogo';
